import deepmerge from 'deepmerge';
const combineMerge = (destination, source) => {
  const array = destination.concat(source);
  // dedupe matching values
  return Array.from(new Set(array));
};
const overwriteMerge = (_, sourceArray) => sourceArray;
export default (state, action, _ref) => {
  let {
    types
  } = _ref;
  switch (action.type) {
    case types.SET_PAYMENT_INFO:
      {
        return {
          ...state,
          ...action.payload
        };
      }
    case types.SET_WALLET_ID:
      {
        return {
          ...state,
          walletId: action.payload
        };
      }

    // merge existing deal ids with incoming deal id
    case types.UPDATE_CREDIT_APP_DEALS:
      {
        return {
          ...state,
          creditAppDeals: deepmerge(state.creditAppDeals, action.payload?.creditAppDeals, {
            arrayMerge: combineMerge
          })
        };
      }
    case types.UPDATE_PAYMENT_INFO:
      {
        return {
          ...state,
          ...action.payload
        };
      }
    case types.UPDATE_USER_TRADE_IN:
      {
        return {
          ...state,
          tradeIn: {
            ...state.tradeIn,
            ...action.payload
          }
        };
      }
    case types.UPDATE_CREDIT_VERIFICATION:
      {
        return {
          ...state,
          creditVerification: {
            ...state.creditVerification,
            ...action.payload
          }
        };
      }
    case types.UPDATE_ICO_TRADE_IN:
      {
        return {
          ...state,
          icoTradeIn: {
            ...action.payload
          }
        };
      }
    case types.UPDATE_PAYMENT_PENCILS:
      {
        return {
          ...state,
          penciling: {
            ...state.penciling,
            ...action.payload
          }
        };
      }
    case types.UPDATE_PENCILING_PAYMENTS:
      {
        return {
          ...state,
          penciling: {
            ...state.penciling,
            pencilingPayments: {
              ...action.payload
            }
          }
        };
      }
    case types.UPDATE_MY_WALLET_INTERACTIONS:
      {
        return {
          ...state,
          interactions: {
            ...state.interactions,
            ...action.payload
          }
        };
      }
    case types.ADD_HIDE_RECEIPT_LISTING:
      {
        return {
          ...state,
          interactions: {
            ...state.interactions,
            hideReceipt: combineMerge(state?.interactions?.hideReceipt ?? [], [action.payload.listingId])
          }
        };
      }
    case types.REMOVE_HIDE_RECEIPT_LISTING:
      {
        const listingIds = state?.interactions?.hideReceipt?.filter(item => item !== action.payload.listingId) ?? [];
        return {
          ...state,
          interactions: {
            ...state.interactions,
            hideReceipt: listingIds
          }
        };
      }
    case types.UPDATE_MY_WALLET:
      {
        return {
          ...state,
          myWallet: {
            ...state.myWallet,
            listingCategory: null,
            // reset listingType to be null if it's not sent from actions
            ...action.payload
          }
        };
      }
    case types.UPDATE_LISTINGS_PAYMENTS:
      {
        return {
          ...state,
          listingPayments: {
            ...state.listingPayments,
            ...action.payload
          }
        };
      }
    case types.UPDATE_LISTINGS_INCENTIVES:
      {
        return {
          ...state,
          // merge incentives to respective listing if exists, as incentives are retrieved on demand for each deal type.
          listingIncentives: deepmerge(state?.listingIncentives ?? {}, action.payload, {
            arrayMerge: overwriteMerge
          })
        };
      }
    case types.UPDATE_LISTING_LEASE_PAYMENTS:
      {
        return {
          ...state,
          listingLeasePayments: {
            ...state.listingLeasePayments,
            ...action.payload
          }
        };
      }
    case types.UPDATE_LISTING_CASH_PAYMENTS:
      {
        return {
          ...state,
          listingCashPayments: {
            ...state.listingCashPayments,
            ...action.payload
          }
        };
      }
    case types.UPDATE_IS_LOADING:
      {
        return {
          ...state,
          ...action.payload
        };
      }
    case types.SET_DEAL_DETAILS:
      {
        return {
          ...state,
          dealDetails: {
            ...state.dealDetails,
            ...action.payload
          }
        };
      }
    case types.UPDATE_DEAL_DETAILS:
      {
        const {
          dealId,
          dealData
        } = action.payload;
        return {
          ...state,
          dealDetails: {
            ...state.dealDetails,
            [dealId]: {
              ...state.dealDetails[dealId],
              ...dealData
            }
          }
        };
      }
    case types.UPDATE_DEAL_NOTIFICATIONS:
      {
        return {
          ...state,
          dealNotifications: {
            ...state.dealNotifications,
            ...action.payload
          }
        };
      }
    case types.RESET_DEAL_NOTIFICATIONS:
      {
        return {
          ...state,
          dealNotifications: {}
        };
      }
    case types.UPDATE_PENCILED_LATEST_PAGE_ID:
      {
        return {
          ...state,
          penciling: {
            ...state.penciling,
            penciledLatestPageId: action.payload
          }
        };
      }
    case types.UPDATE_PENCILED_VDP_LISTINGS:
      {
        return {
          ...state,
          penciling: {
            ...state.penciling,
            penciledVdpListings: [...(state.penciling?.penciledVdpListings || []), action.payload]
          }
        };
      }
    default:
      return state;
  }
};